import React from "react";
import Icon from "@ant-design/icons";
import type { SVGProps } from "react";

const WarningTriangleSvg = (props: SVGProps<SVGSVGElement>) => {
  const { width = "1em", height = "1em", ...restProps } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M32 8c.8 0 1.54.42 1.94 1.11l23.1 40.01c.81 1.41-.2 3.18-1.94 3.18H8.9c-1.74 0-2.75-1.77-1.94-3.18l23.1-40.01A2.2 2.2 0 0 1 32 8Z"
        fill="#FF4C4C"
        stroke="#FF4C4C"
        strokeLinejoin="round"
      />
      <rect
        x="29"
        y="22"
        width="6"
        height="18"
        rx="3"
        fill="#fff"
      />
      <circle
        cx="32"
        cy="46"
        r="3"
        fill="#fff"
      />
    </svg>
  );
};

export const WarningTriangleIcon = (props: React.ComponentProps<typeof Icon>) => (
  <Icon component={WarningTriangleSvg} {...props} />
);
